import { useEffect, useState } from "react";
import styled from "styled-components";

import * as UI from "../../../../../../modules/ui-kit";
import Properties from "../Properties";

const Styled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 32px;
`;

export default function LayerDetail(props) {
    const {
        id,
        onChange,
        onClose,
        properties,
    } = props;

    const [updatedID, setID] = useState(undefined);
    useEffect(
        () => setID(id),
        [id],
    );

    const [updatedProperties, setProperties] = useState(undefined);
    useEffect(
        () => setProperties(properties),
        [properties],
    );

    function onSubmit(event) {
        event.preventDefault();

        const update = {};
        if (updatedID !== undefined) update.id = updatedID;
        if (updatedProperties !== undefined) update.properties = updatedProperties;

        onChange(update);
        onClose();
    }

    return (
        <Styled>
            material identifier
            <UI.TextInput
                onChange={ setID }
                value={ updatedID ?? "" }
            />
            properties
            <Properties
                onChange={ setProperties }
                value={ updatedProperties ?? [] }
            />
            <UI.Button
                $appearance="primary"
                onClick={ onSubmit }
            >
                Save
            </UI.Button>
        </Styled>
    );
}
